import app from "app.controller"

app.language.changed.add(() => {
  $fetch.clear()
})

let memory = new Map()

function $fetch(url, opts, { retry = false } = {}) {
  let hash = url
  if (opts.body) hash = hash + JSON.stringify(opts.body)
  let p = memory.get(hash)
  if (!p) {
    p = fetch(url, opts)
      .then(res => res.json())
      .catch(err => {
        memory.delete(hash)
        if (!retry) {
          console.warn("Error. One retry left", err)
          retry = true
          return $fetch(url, opts, { retry: true })
        }
        else {
          let newError = `Failed after 2 retries: ${err}, ${url} `
          console.error(newError)
          throw new Error(newError)
        }
      })
    memory.set(hash, p)
  }
  return p
}

$fetch.clear = function () {
  memory = new Map()
}

export default $fetch



// WEBPACK FOOTER //
// ./src/sdk/$fetch.js